import type { PricesInterface, PricePeriodType } from '@/modules/common/common/models/APP/types'
import type { InsuranceHighlightsInterface } from '@/modules/common/common/models/APP/types'
import type AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import { priceFormat } from '@/utils/textUtils'
import { CURRENCY } from '@/modules/common/common/constants/CommonConstants'

const EMPTY_PRICE_STRING = '-- -- '

export default class Insurance {
  quotationNumber: string | null
  clientCode: string | null
  productCode: string | null
  productName: string | null
  businessLine: string | null
  reimbursement: number | null

  image: string | null
  highlights: InsuranceHighlightsInterface[]
  sections: AbstractAccordion<any>[]
  order: number

  group: string
  title: string
  description: string
  type: string
  prices: PricesInterface
  totalPrices: PricesInterface
  units: string

  constructor(data: Partial<Insurance>) {
    this.quotationNumber = data.quotationNumber ?? null
    this.clientCode = data.clientCode ?? null
    this.productCode = String(data?.productCode) || null
    this.productName = data.productName ?? null
    this.businessLine = data.businessLine ?? null
    this.image = data.image ?? null

    this.highlights = data.highlights ?? []
    this.sections = data.sections ?? []
    this.order = data.order ?? 0

    this.group = data.group ?? ''
    this.title = data.title ?? ''
    this.description = data.description ?? ''
    this.type = data.type ?? ''
    this.prices = data.prices ?? {}
    this.totalPrices = data.totalPrices ?? {}
    this.units = data.units ?? CURRENCY

    this.reimbursement = data.reimbursement ?? 0
  }

  get id() {
    return this.productCode ?? ''
  }

  getPriceWithUnits(period: PricePeriodType): string {
    const pricePeriod = period as keyof typeof this.prices
    const price =
      period in this.prices
        ? this.prices[pricePeriod]
          ? priceFormat(this.prices[pricePeriod]!)
          : this.prices[pricePeriod]
        : EMPTY_PRICE_STRING

    return `${price}${this.units}`
  }

  getMandatoryFeatures(): any[] {
    return []
  }
}
